import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';


import { CustomHttp, ConfigServerService } from '../../../../core';
import { UnidadeNegocioNaturezaVendaFilter } from '../filter';
import { UnidadeNegocioNaturezaVenda } from '../unidade-negocio-natureza-venda';

@Injectable({
    providedIn: 'root'
})
export class UnidadeNegocioNaturezaVendaHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/unidadenegocio`;
    }

    /** Pesquisa todos as naturezas de vendas vinculadas a unidade de negócio informada */
    search(idUnidadeNegocio: number, filter: UnidadeNegocioNaturezaVendaFilter): Observable<UnidadeNegocioNaturezaVenda[]> {
        // Params
        let params = new HttpParams();
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<UnidadeNegocioNaturezaVenda[]>(`${this.pathApi}/${idUnidadeNegocio}/naturezavenda`, {params});
    }

    /** Obtem o formulário para os itens da cotação da unidade de negócio e natureza de venda informadas */
    getCotacaoItemFormulario(idUnidadeNegocio: number, idNaturezaVenda: number): Observable<number> {
        return this.customHttp.get<number>(`${this.pathApi}/${idUnidadeNegocio}/naturezavenda/${idNaturezaVenda}/cotacaoitemformulario`);
    }
}
